import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function NavBar() {
  return (
    <Navbar bg="primary" variant="dark" expand="lg">
      <Navbar.Brand exact as={NavLink} to="/">
        <img alt="Icon" src="/logo192.png" width="30" height="30" className="d-inline-block align-top mr-2" />
        Mdcp Dashboard
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="navbar-nav" />
      <Navbar.Collapse id="navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link exact as={NavLink} to="/">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'thermometer-half']} />
            Status
          </Nav.Link>

          <Nav.Link as={NavLink} to="/elastic">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'search']} />
            Elasticsearch
          </Nav.Link>

          <Nav.Link as={NavLink} to="/reindex">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'recycle']} />
            Content Graph Reindex
          </Nav.Link>

          <Nav.Link as={NavLink} to="/selene-reindex">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'recycle']} />
            Selene Reindex
          </Nav.Link>

          <Nav.Link as={NavLink} to="/elasticVisualization">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'chart-pie']} />
            Visualization
          </Nav.Link>

          <Nav.Link as={NavLink} to="/queueManagement">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'envelope']} />
            Queue
          </Nav.Link>

          <Nav.Link as={NavLink} to="/exclusions">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'clipboard-list']} />
            Exclusions
          </Nav.Link>

          <Nav.Link as={NavLink} to="/autoVersioning">
            <FontAwesomeIcon className="mr-2 d-lg-none d-xl-inline-block" icon={['fas', 'hat-wizard']} />
            Auto Versioning
          </Nav.Link>
        </Nav>
        <NavDropdown.Divider className="d-lg-none" />
      </Navbar.Collapse>
    </Navbar>
  )
}
